import { render } from "./openask.vue?vue&type=template&id=6c6ff9fd"
import script from "./openask.vue?vue&type=script&lang=js"
export * from "./openask.vue?vue&type=script&lang=js"

import "./openask.vue?vue&type=style&index=0&id=6c6ff9fd&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__